<template>
  <div class="auto-match-container">
    <div class="selects">
      <options-selected :selectedTypes="selectedTypes" @delete="deleteSelected"></options-selected>
      <input type="textarea" class="input-style" :class="{'positionInit': positionInit}" v-model="k"
        :placeholder="holder" @focus="focusFn(k)" @input="inputFn(kk)" @keydown.40="userSelectOption('down')"
        @keydown.38="userSelectOption('up')" @keydown.delete="deleteFn" @keydown.enter="enterPushFn(k)"
        @blur="blurFn" />
      <ul class="types" ref="types" v-if="typesIsDisplay && selectingTypes.length">
        <li class="type"
          :class="{'SelectedByUser': !isMouseMoving && userSelectIdx === index,'isMousMoving':isMouseMoving}"
          :ref="`selectingType${index}`" @mouseover="mouseOverFn(index)" @mousedown="mouseDownFn(type)"
          v-for="(type, index) in selectingTypes" :key="index">
          <span>{{ formatName(type) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
// import autoTextarea from './auto-textarea'
import optionsSelected from './optionsSelected.vue'

export default {
  data () {
    return {
      selectingTypes: [], // 用户输入中被选中标签们
      selectedTypes: this.value, // 用户确定已经选中标签们
      userSelectIdx: -1, // 用户选中的标签在选中的标签们的索引值
      userMouseSelectIdx: -1,
      kk: '', // k 的中间状态值 用于传递截流
      typesIsDisplay: false, // 控制 用户输入中被选中标签们的 显示／隐藏
      isMouseMoving: false, // 当前选中的标签们是否在鼠标悬停
      positionInit: false,
      MapTypes: [], // 只有name
      holder: this.placeholder
    }
  },
  components: {
    // autoTextare
    optionsSelected
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    types: {
      type: Array,
      default: () => {
        return []
      }
    },
    dataSource: {
      type: String,
      default: 'static' // 'ajax'
    },
    tkey: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入关键词'
    },
    singleSelect: {
      type: Boolean,
      default: false
    },
    allowCustom: {
      type: Boolean,
      default: false
    },
    formatName: {
      type: Function,
      default: (type) => { return type.name }
    }
  },
  methods: {
    filterTypes (key) {
      if (!key) {
        return []
      } else if (this.dataSource === 'static') {
        return this.types.filter(t => { return t['name'].indexOf(key) > -1 })
      } else {
        this.$emit('searchKey', key)
        return []
      }
    },
    userSelectOption (direction) {
      if (this.selectingTypes.length) {
        this.isMouseMoving = false
        if (this.userMouseSelectIdx !== -1) {
          this.userSelectIdx = this.userMouseSelectIdx
          this.userMouseSelectIdx = -1
        }
        if (direction === 'down') {
          if (this.userSelectIdx <= this.selectingTypes.length - 1) {
            // console.log(this.userSelectIdx)
            this.userSelectIdx++
          }
          if (this.userSelectIdx > this.selectingTypes.length - 1) {
            this.userSelectIdx = -1
          }
        } else if (direction === 'up') {
          if (this.userSelectIdx >= 0) {
            this.userSelectIdx--
          } else if (this.userSelectIdx === -1) {
            this.userSelectIdx = this.selectingTypes.length - 1
          }
        }
      }
    },
    setTypesDisplay (typesIsDisplay) {
      this.typesIsDisplay = typesIsDisplay
    },
    checkIsType (kk) {
      if (kk) {
        return this.types.filter(t => { return t.name === kk })
      }
    },
    pushSelectedTypes (type) {
      if (this.singleSelect) {
        // 单选就直接赋值
        this.selectedTypes = [type]
        this.$emit('setSelectedTypes', { key: this.tkey, value: this.selectedTypes })
        this.$emit('blur')
      } else {
        if (!this.selectedTypes.some(t => { return Number(t.id) === Number(type.id) })) {
          this.selectedTypes.push(type)
          this.$emit('setSelectedTypes', { key: this.tkey, value: this.selectedTypes })
          this.$emit('blur')
        }
      }
    },
    blurFn () {
      if (this.allowCustom && this.kk) {
        const customType = { name: this.kk }
        this.pushSelectedTypes(customType)
      }
      this.k = ''
      this.setTypesDisplay(false)
      if (this.userSelectIdx !== -1) {
        this.kk = this.selectingTypes[this.userSelectIdx].name
      }
      this.selectingTypes = []
      this.userSelectIdx = -1
      this.$emit('blur')
    },
    focusFn (k) {
      this.setTypesDisplay(true)
      this.userMouseSelectIdx = -1
      this.$emit('focus')
      this.selectingTypes = this.filterTypes(k)
    },
    mouseOverFn (index) {
      this.isMouseMoving = true
      this.userMouseSelectIdx = index
    },
    mouseDownFn (type) {
      this.pushSelectedTypes(type)
      this.kk = ''
      this.userSelectIdx = -1
    },
    enterPushFn (k) {
      if (this.allowCustom && this.kk) {
        const customType = { name: this.kk }
        this.pushSelectedTypes(customType)
      }
      let isOfType = this.checkIsType(k) || []
      if (isOfType.length) this.pushSelectedTypes(isOfType[0])
      this.setTypesDisplay(false)
      this.kk = ''
      this.userSelectIdx = -1
    },
    inputFn (kk) {
      this.setTypesDisplay(true)
      this.selectingTypes = this.filterTypes(kk)
    },
    deleteFn () {
      this.userSelectIdx = -1
      if (!this.k && this.selectedTypes.length) {
        this.selectedTypes.pop()
        this.$emit('setSelectedTypes', { key: this.tkey, value: this.selectedTypes })
        this.$emit('blur')
      }
    },
    inputHandler () {
      if (this.selectedTypes.length) {
        this.$nextTick(() => {
          this.$el.querySelector('input').style.width = (this.$el.querySelector('.selects').offsetWidth - this.$el.querySelector('.input-style').offsetLeft) + 'px'
        })
      } else {
        this.$nextTick(() => {
          this.$el.querySelector('input').style.width = '100%'
        })
      }
    },
    deleteSelected (index) {
      this.selectedTypes.splice(index, 1)
      this.$emit('setSelectedTypes', { key: this.tkey, value: this.selectedTypes })
      this.$emit('blur')
    }
  },
  computed: {
    k: {
      get: function () {
        if (this.userSelectIdx === -1) {
          return this.kk
        } else {
          if (this.selectingTypes[this.userSelectIdx]) {
            return this.selectingTypes[this.userSelectIdx].name || ''
          } else {
            return ''
          }
        }
      },
      set: function (n) {
        this.kk = n
      }
    }
  },
  watch: {
    'value': {
      handler: function (newVal) {
        if (newVal) {
          this.selectedTypes = newVal
        }
      },
      deep: true,
      immediate: true
    },
    'selectedTypes': {
      handler: function (n, o) {
        this.inputHandler()
        if (!n.length) {
          this.positionInit = true
          this.holder = this.placeholder
        } else {
          this.positionInit = false
          this.holder = ''
        }
      },
      deep: true,
      immediate: true
    },
    'types': function (n, o) {
      if (this.dataSource === 'static') return
      this.selectingTypes = n
    },
    'userSelectIdx': function (n, o) {
      if (this.$refs[`selectingType${n + 1}`] && this.$refs['types'].clientHeight === 196) {
        this.$refs['types'].scrollTop = (this.$refs[`selectingType${n + 1}`][0].offsetTop - this.$refs['types'].clientHeight + 5)
      }
      if (n === this.selectingTypes.length - 1) {
        this.$refs['types'].scrollTop = this.$refs['types'].scrollHeight - this.$refs['types'].clientHeight
      }
    }
  }
}
</script>
<style lang='sass' scoped>
@import '../../style/bulma/app.sass'

.auto-match-container
  position: relative
  padding: 4px 12px
  .selects
    display: inline-block
    width: 100%
    background-color: transparent
    height: 28px
    input.input-style
      position: absolute
      // z-index: 1
      // float: left
      width: 100%
      height: 28px
      outline: none
      border: none
      background-color: transparent
      font-size: 14px
      -webkit-appearance: textfield
      // +input-placeholder('#bbbec4', '12px')
      &::-webkit-input-placeholder  /* WebKit, Blink, Edge */
        color: #bbbec4
        font-size: 12px
      &:-moz-placeholder  /* Mozilla Firefox 4 to 18 */
        color: #bbbec4
        font-size: 12px
      &::-moz-placeholder  /* Mozilla Firefox 19+ */
        color: #bbbec4
        font-size: 12px
      &:-ms-input-placeholder /* Internet Explorer 10-11 */
        color: #bbbec4
        font-size: 12px
      &.positionInit
        position: inherit
    .types
      width: 100%
      margin-left: -12px
      position: absolute
      bottom: -5px
      max-height: 196px
      padding: 5px 0
      overflow: auto
      transform: translateY(100%)
      will-change: top, left
      transform-origin: center top 0px
      transition: all 0.3s linear
      display: flex
      flex-direction: column
      background-color: #fff
      border-radius: 4px
      box-shadow: 0 1px 6px rgba(0,0,0,.2)
      z-index: 900
      .type
        padding: 5px 15px
        cursor: pointer
        font-size: 14px

        &.SelectedByUser
          background-color: #f3f3f3
      .isMousMoving:hover
          background-color: #f3f3f3
</style>
